import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useWebSocket from 'react-use-websocket';
import { setAppWorkingOn } from '../../../utils/workingOnSlice';

const APP_ACTIVITY_WS_URL = 'wss://backendapi.homesforsalemedia.com/ws/app-activity/';

// Mounted once in Layout. Pushes "working on this file" changes made by any
// user into the workingOn overlay so every loaded card/detail updates in place.
export default function useAppActivitySocket(enabled) {
    const dispatch = useDispatch();

    const handleMessage = useCallback((message) => {
        try {
            const parsed = JSON.parse(message.data);
            const data = parsed?.message?.type ? parsed.message : parsed;
            if (data?.type === 'app_working_on') {
                dispatch(setAppWorkingOn(data));
            }
        } catch (err) {
            console.error('Error parsing app-activity websocket message:', err);
        }
    }, [dispatch]);

    useWebSocket(enabled ? APP_ACTIVITY_WS_URL : null, {
        onMessage: handleMessage,
        onError: (error) => console.error('App activity WebSocket error:', error),
        shouldReconnect: () => true,
        reconnectAttempts: 10,
        reconnectInterval: 3000,
    });
}
